import { render, staticRenderFns } from "./classDetials.vue?vue&type=template&id=0f2ff10e&scoped=true&"
import script from "./classDetials.vue?vue&type=script&lang=js&"
export * from "./classDetials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ff10e",
  null
  
)

export default component.exports